module.exports = __webpack_public_path__ + "static/media/jatin_pathi.89be9eb8.jpg";